import {Injectable} from '@angular/core';

import {Observable} from "rxjs";

import {Project} from '../_models/index';
import {AuthenticationService} from './index';
import {LoginHelper} from '../helpers';
import {FixDates} from "../_decorators/date.decorator";
import {Load} from "../_decorators/loading.decorator";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import {IndexConfigService} from "./index.config.service";
import {ActionPlan} from "../_models/actionPlan";

@Injectable()
export class ProjectService {

  constructor(public http: HttpClient,
              public authenticationService: AuthenticationService,
              public config: IndexConfigService) {
  }

  @FixDates()
  @Load()
  getAll() {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {

      this.authenticationService.logout();
      return null;
    }

    return this.http
      .get<any>(this.config.api + '/api/projects/all');
  }

  @Load()
  getAllShort() {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {

      this.authenticationService.logout();
      return null;
    }

    return this.http
      .get<any>(this.config.api + '/api/projects/all/short');
  }

  @Load()
  getAllShortWithComplianceAreas() {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {

      this.authenticationService.logout();
      return null;
    }

    return this.http
      .get<any>(this.config.api + '/api/projects/all/short/admin/area');
  }

  @Load()
  getAllShortAdmin() {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {

      this.authenticationService.logout();
      return null;
    }

    return this.http
      .get<any>(this.config.api + '/api/projects/all/short/admin');
  }

  @Load()
  downloadActionPlan(projectId, clientItProfileId, fedRampVersion): Observable<any> {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .get(this.config.api + '/api/projects/auditPlan/' + projectId + '/' + clientItProfileId + '/' + fedRampVersion, {responseType: 'arraybuffer', observe:'response', headers: {}});
  }

  @Load()
  uploadSsp(projectId, itProfileId, complianceAreaIds, projectName, profileName, entity, additionalUserId){

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    let formData = new FormData();

    formData.append(entity.name, entity, entity.name);

    return this.http
      .post<any>(this.config.api + '/api/projects/ssp/' + projectId + '/' + itProfileId + '/' + (complianceAreaIds || []).join(',') + '?projectName=' + encodeURIComponent(projectName) + '&profileName=' + profileName + '&additionalUserId=' + additionalUserId, formData)
      ;

  }

  @Load()
  uploadOscal(projectId, itProfileId, complianceAreaIds, projectName, profileName, entity, additionalUserId){

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null){
      this.authenticationService.logout();

      return null;
    }

    let formData = new FormData();

    formData.append(entity.name, entity, entity.name);

    return this.http
      .post<any>(this.config.api + '/api/projects/oscal?projectName=' + encodeURIComponent(projectName), formData)
      ;

  }

  @Load()
  downloadCRM(projectId, clientItProfileId): Observable<any> {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .get(this.config.api + '/api/projects/crm/' + projectId + '/' + clientItProfileId, {responseType: 'arraybuffer', headers: {}});
  }

  @Load()
  getUsersAllProjects(userId: number) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .get<any>(this.config.api + '/api/projects/user/' + userId + '');
  }

  @Load()
  getUsersAllProjectsImplemented(userId: number) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .get<any>(this.config.api + '/api/projects/user/' + userId + '/implemented');
  }

  getActionPlans(userId: number) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .get<any>(this.config.api + '/api/project/actionPlan/user/' + userId + '');
  }

  @Load()
  getImplementationStatus(projectId: number, frequency: number = -1) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .get<any>(this.config.api + '/api/reports/implementationStatus?projectId=' + projectId + '&frequency=' + frequency);
  }

  @FixDates()
  @Load()
  getById(id: number) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .get<any>(this.config.api + '/api/projects/project/' + id + '');

    //.toPromise()
    //.then((response: any) => response.json())
    //.then(data => { return data; })
  }

  @Load()
  getForPoam(id: number) {
    return this.getForPoamNoLoading(id);
  }

  @FixDates()
  getForPoamNoLoading(id: number) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .get<any>(this.config.api + '/api/projects/project/poam/' + id + '');

    //.toPromise()
    //.then((response: any) => response.json())
    //.then(data => { return data; })
  }

  @Load()
  getForPoamGlobal() {
    return this.getForPoamGlobalNoLoading();
  }

  @FixDates()
  getForPoamGlobalNoLoading() {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .get<any>(this.config.api + '/api/projects/project/poamGlobal');

    //.toPromise()
    //.then((response: any) => response.json())
    //.then(data => { return data; })
  }

  @Load()
  @FixDates()
  savePoam(poam: any) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .post<any>(this.config.api + '/api/projects/project/poam', poam);

    //.toPromise()
    //.then((response: any) => response.json())
    //.then(data => { return data; })
  }

  @FixDates()
  getByIdAndDueDate(id: number, dueDate: string) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .get<any>(this.config.api + '/api/projects/project/' + id + '/' + dueDate);
  }

  getWithoutEvidence(id: number) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .get<any>(this.config.api + '/api/projects/project/withoutEvidence/' + id + '');
  }

  @Load()
  getControlsByProject(projectId: number): Observable<any[]> {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();
      return null;
    }

    return this.http.get<any[]>(this.config.api + '/api/projects/${projectId}/controls');
  }

  @FixDates()
  @Load()
  create(project: Project) {

    const tenantName = project.tenantName;
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .post<any>(this.config.api + '/api/projects/create', project);
  }

  @Load()
  @FixDates()
  update(project: Project, withFiles: boolean) {

    const tenantName = project.tenantName;
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    project.tenantName = tenantName;

    return this.http
      .put(this.config.api + '/api/projects/update/' + project.projectId + '/' + withFiles, project);
  }

  @Load()
  delete(id: number, withFiles: boolean) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .delete(this.config.api + '/api/projects/delete/' + id + '/' + withFiles + '');
  }

  getAccessRights(id: number) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .get<any>(this.config.api + '/api/projects/accessRights/' + id + '');
  }

  @Load()
  saveAccessRights(projectId, data) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .post<any>(this.config.api + '/api/projects/accessRights/' + projectId + '', data);
  }

  @Load()
  updatePOAMId(projectControlItemId, pOAMId) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .post<any>(this.config.api + '/api/projects/pOAMId/' + projectControlItemId + '', {pOAMId: pOAMId});
  }

  @Load()
  uploadProjectData(entity: File, projectId: number/*, complianceAreaId: string*/) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    let formData = new FormData();

    formData.append(entity.name, entity, "projectData.xlsx");

    return this.http
      .post<any>(this.config.api + `/api/project/upload/${projectId}`, formData);
  }

  @Load()
  uploadPoamData(entity: File, projectId: number/*, complianceAreaId: string*/) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    let formData = new FormData();

    formData.append(entity.name, entity, "projectData.xlsx");

    return this.http
      .post<any>(this.config.api + `/api/project/upload/poam/${projectId}`, formData);
  }

  getProjectControlItemsPairings(tenantName: string = null) {

    if (tenantName == null) {
      tenantName = LoginHelper.getTenantName();
      if (tenantName == null || LoginHelper.getUserToken() == null) {
        this.authenticationService.logout();

        return null;
      }
    }

    return this.http.get<any>(this.config.api + '/api/project/pairings');
  }

  @Load()
  addPairing(from: number, to: number, isPrimary: boolean, subComponents: any, tenantName: string = null) {
    if (tenantName == null) {
      tenantName = LoginHelper.getTenantName();
      if (tenantName == null || LoginHelper.getUserToken() == null) {
        this.authenticationService.logout();
        return null;
      }
    }
    const body = { from, to, isPrimary, subComponents };
    console.log('Sending body:', body);
    return this.http.post<any>(this.config.api + '/api/project/pairings', body);
  }

  @Load()
  deletePairing(id: number, tenantName: string = null) {

    if (tenantName == null) {
      tenantName = LoginHelper.getTenantName();
      if (tenantName == null || LoginHelper.getUserToken() == null) {
        this.authenticationService.logout();

        return null;
      }
    }

    return this.http.delete(this.config.api + '/api/project/pairings/' + id);
  }

  @Load()
  getClonedStatus(tenantName: string = null) {

    if (tenantName == null) {
      tenantName = LoginHelper.getTenantName();
      if (tenantName == null || LoginHelper.getUserToken() == null) {
        this.authenticationService.logout();

        return null;
      }
    }

    return this.http.get<any>(this.config.api + '/api/project/clonedStatus');
  }

  @FixDates()
  @Load()
  addPairings(sourceProjectId: number, pairs: any[]) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .post<any>(this.config.api + '/api/project/multiplepairings/' + sourceProjectId + '', pairs);
  }

  @Load()
  getScoringReportData(projectId: number) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http.get<any>(this.config.api + `/api/project/${projectId}/scoringReport`);
  }

  @FixDates()
  @Load()
  getCidReport(id: number) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .get<any>(this.config.api + '/api/projects/project/' + id + '/cidreport');
  }

  @Load()
  applyMappingTemplate(fromProjectId, toProjectId, mappingTemplateId, apply) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .post<any>(this.config.api + '/api/project/applymappingtemplate/' + fromProjectId + '/' + toProjectId + '/' + mappingTemplateId + '/' + apply, {});
  }

  @Load()
  applyMapping(projectId) {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .post<any>(this.config.api + '/api/project/applymapping/' + projectId + '', {});
  }

  @Load()
  removeMapping(projectId) {
    return this.http
      .post<any>(this.config.api + '/api/project/removemapping/' + projectId + '', {});
  }

  @Load()
  getServicesForProject(projectId) {
    return this.http
      .get<any>(this.config.api + '/api/project/services/' + projectId + '', {});
  }
  @Load()
  getServicesReport(projectId) {
    return this.http
      .get<any>(this.config.api + '/api/project/services/' + projectId + '/report', {});
  }

  @Load()
  downloadActivityReport(projectId, month, year): Observable<any> {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return null;
    }

    return this.http
      .get(this.config.api + `/api/projects/project/${projectId}/activityreport?month=${month}&year=${year}`, {responseType: 'arraybuffer', headers: {}});
  }
}

